import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Layout components
import TopBar      from './components/TopBar/TopBar';
import Navbar      from './components/Navbar/Navbar';
import Footer      from './components/Footer/Footer';
import SocialSidebar from './components/SocialSidebar/SocialSidebar';
import AIAgent     from './components/AIAgent/AIAgent';

// Home page sections
import Hero        from './components/Hero/Hero';
import Marquee     from './components/Marquee/Marquee';
import Listings    from './components/Listings/Listings';
import Carousel    from './components/Carousel/Carousel';
import Stats       from './components/Stats/Stats';
import PropertySlider from './components/PropertySlider/PropertySlider';
import WhyUs       from './components/WhyUs/WhyUs';
import Testimonials from './components/Testimonials/Testimonials';
import OurServices from './components/OurServices/OurServices';
import BookingForm from './components/BookingForm/BookingForm';
import CTABanner   from './components/CTABanner/CTABanner';

// Pages
import ProjectsPage     from './pages/ProjectsPage';
import ServicesPage     from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import LocationPage     from './pages/LocationPage';
import ContactPage      from './pages/ContactPage';

// Home assembled
function HomePage() {
  return (
    <>
      <Hero />
      <Marquee />
      <Listings />
      <Carousel />
      <Stats />
      <PropertySlider />
      <WhyUs />
      <Testimonials />
      <OurServices />
      <BookingForm />
      <CTABanner />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <TopBar />
      <Navbar />

      <Routes>
        <Route path="/"               element={<HomePage />} />
        <Route path="/projects"       element={<ProjectsPage />} />
        <Route path="/services"       element={<ServicesPage />} />
        <Route path="/services/:slug" element={<ServiceDetailPage />} />
        <Route path="/location"       element={<LocationPage />} />
        <Route path="/contact"        element={<ContactPage />} />
      </Routes>

      <Footer />
      <SocialSidebar />
      <AIAgent />
    </BrowserRouter>
  );
}

export default App;
